<div
  class="verify-page page-wrapper page-wrapper--fullscreen-min page-wrapper--column"
>
  @if (this.unsubscribeForm()) {
    @if (unsubscribeForm().organizationLogo; as orgLogo) {
      <fmnts-scale-image
        [image]="orgLogo"
        horizontalAlignment="center"
      ></fmnts-scale-image>
    }

    <div class="verify-form__wrapper">
      <verify-form-page
        [page]="unsubscribeForm().form"
        [pages]="[unsubscribeForm().form]"
        [storeId]="[this.hash(), 'unsubscribe']"
        (action)="this.handleAction($event)"
      ></verify-form-page>
    </div>
  }
  @if (emptyState(); as empty) {
    <div class="verify-form__wrapper">
      <span class="error">
        @if (empty.translate) {
          {{ empty.text | translate }}
        } @else {
          {{ empty.text }}
        }
      </span>
    </div>
  }
</div>
